import { render, staticRenderFns } from "./Bimini_steakSection.vue?vue&type=template&id=00bd4234&scoped=true"
import script from "./Bimini_steakSection.vue?vue&type=script&lang=ts"
export * from "./Bimini_steakSection.vue?vue&type=script&lang=ts"
import style0 from "./Bimini_steakSection.vue?vue&type=style&index=0&id=00bd4234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd4234",
  null
  
)

export default component.exports